import { Api } from 'utils';

class ReportsService {

  static payemntsRecieved = async (params?: any) => Api.createResponse('admin/reports/payments-recieved', params);
  static payemntsMade = async (params?: any) => Api.createResponse('admin/reports/payments-made', params);
  static createPaymentsMade = async (params?: any) => Api.createResponse('admin/reports/create-payment-made', params);
  static plansSummary = async (params?: any) => Api.createResponse('admin/reports/plans', params);
  static assignedAppoinments = async (params?: any) => Api.createResponse('admin/reports/assigned-appoinments', params);

  // CHARTS
  static userAvg = async (params?: any) => Api.createResponse('admin/reports/chart/user-avg', params);
  static appoinments = async (params?: any) => Api.createResponse('admin/reports/chart/appoinments', params);
  static plansChart = async (params?: any) => Api.createResponse('admin/reports/chart/plans', params);
  static ratings = async (params?: any) => Api.createResponse('admin/reports/chart/ratings', params);

  static doctorRatings = async (params?: any) => Api.createResponse('admin/reports/ratings', params);
  static doctorComments = async (params?: any) => Api.createResponse('admin/reports/ratings/comments', params);
}

export default ReportsService;